module.exports = __webpack_public_path__ + "static/media/EG.d6440798.svg";